import { BaseContainerModel } from "../base-container.model";
import { bl_wms_warehouse_layout_node_hdr_RowInterface, bl_wms_warehouse_layout_node_hdr_RowClass } from "../../dbschema/index";

export class WarehouseLayoutNodeHdrContainerModel extends BaseContainerModel {
    bl_wms_warehouse_layout_node_hdr: bl_wms_warehouse_layout_node_hdr_RowInterface = new bl_wms_warehouse_layout_node_hdr_RowClass();
}
